// extracted by mini-css-extract-plugin
export default {"Body":"qH9SqeBWum1T6KlVtDFo","Controls":"namgHP0ABn73x5pALxO2"};